module.exports = __webpack_public_path__ + "static/media/download.84966e19.png";